import React from 'react';
import { SWOTAnalysis } from '../types';
import { AnalysisCard } from './AnalysisCard';

interface AnalysisListProps {
  analyses: SWOTAnalysis[];
}

export const AnalysisList: React.FC<AnalysisListProps> = ({ analyses }) => {
  if (analyses.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8 text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">التحليلات السابقة</h2>
        <p className="text-gray-600">لا يوجد تحليلات سابقة</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">التحليلات السابقة</h2>
      <div className="space-y-8">
        {analyses.map((analysis) => (
          <AnalysisCard key={analysis.id} analysis={analysis} />
        ))}
      </div>
    </div>
  );
};